import { render, staticRenderFns } from "./CardManagement.vue?vue&type=template&id=90a716b2"
import script from "./CardManagement.vue?vue&type=script&lang=js"
export * from "./CardManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports